import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InfoIcon from '@mui/icons-material/Info';
import { AccountApi, DistributorApi } from '../../apis/index';
import ReactSecureStorage from 'react-secure-storage';
import ApartmentIcon from '@mui/icons-material/Apartment';

const DistirbutorRequestList = (props) => {
  const [requestList, setRequestList] = useState([]);
  const [memberType, setMemberType] = useState([]);

  const firstSerach = async () => {
    setMemberType(ReactSecureStorage.getItem('memberType'));
    const res = await DistributorApi.getRequestAccountList(ReactSecureStorage.getItem('email'), 
    ReactSecureStorage.getItem('org'), 'DISTRIBUTOR');

    if (res.data !== null) {
      const modifiedRequestList = res.data.map((item, index) => ({
        ...item,
        id: index + 1,
        approved: item.approved ? 'Approved' : 'Not Approved',
        modifyDate: item.modifyDate.replace(/:\d{2}\.\d{3}\+\d{2}:\d{2}$/, 'Z'),
      }));
      setRequestList(modifiedRequestList); 
    }
  };
  useEffect(() => {
    firstSerach();
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID', width: 100 },
    { field: 'memberName', headerName: 'Organization Name', width: 260 },
    { field: 'email', headerName: 'Email', width: 290 },
    { field: 'department', headerName: 'Department', width: 160 },
    { field: 'approved', headerName: 'Status', width: 120 },
    { field: 'modifyDate', headerName: 'Request Date', width: 170 },
  ];

  const handleRowSelection = (e) => {
    props.history.push('/distributorApprove/' + e.row.encryptId);
  };
  return (
    <div>
      <Grid>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ paddingBottom: 10 }}
        >
          <div
            variant="h6"
            style={{ fontWeight: 'bold', color: 'rgb(63, 89, 140)', fontSize: '24px'  }}
          >
            ACCOUNT LIST
          </div>
          {memberType && !memberType.includes('ROKIT_BD') && (
            <button className="blue">
              <Link to="/distributorRequest" style={{ textDecoration: 'none' }}>
                <ApartmentIcon
                  label="Distributor Request"
                  style={{
                    color: 'rgb(63, 89, 140)',
                    opacity: '90%',
                  }}
                />
                <span> NEW ACCOUNT REQUEST</span>
              </Link>
            </button>
          )}
        </Grid>
      </Grid>

      <div style={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={requestList}
          columns={columns}
          pageSize={10}
          onRowSelected={memberType.includes('ROKIT_BD') ? handleRowSelection : null}
          onRowClick={memberType.includes('ROKIT_BD') ? handleRowSelection : null}
        />
      </div>
    </div>
  );
};

export default DistirbutorRequestList;
